import { useNavigate, useParams } from 'react-router-dom';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { validateOrderId, getStorageOrder } from '../../data/API';
import { ReactSession } from 'react-client-session';
import uuid from 'react-uuid';
import { resetStore } from '../StorageBox/store/actionCreators';
import { resetReduxStore } from '../Packages/store/actionCreators';
import { getToken } from '../../utils/token';

  export default function OrderConfirmation() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const order_Id = useSelector((state) => state.package.orderId);
    const [isValidOrder, setIsValidOrder] = useState(true);
    const [currentOrderType, setCurrentOrderType] = useState(''); // Store orderType in state
    let { orderId } = useParams();
    orderId = order_Id ?? orderId;
    
    useEffect(() => {
      const orderType = sessionStorage.getItem('orderType');
      setCurrentOrderType(orderType || '');
    }, []);

     // Track the "COMPLETE_REGISTRATION" event when the component mounts
    useEffect(() => {
      // Fire the event only once when the page loads
      if (orderId) {
        // 1. Push to dataLayer for Google Tag Manager
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'COMPLETE_REGISTRATION',
          'orderId': orderId,
          'orderType': currentOrderType || 'unknown'
        });

        // 2. Fire Facebook Pixel event directly
        if (window.fbq) {
          window.fbq('track', 'CompleteRegistration', {
            order_id: orderId,
            order_type: currentOrderType || 'unknown'
          });
        }
      }
    }, [orderId, currentOrderType]);

    useEffect(() => {
      dispatch(resetReduxStore());
      localStorage.removeItem('driverTip');
      
    }, [currentOrderType]);

    const getorderFunc = async (id) => {
      try {
        if (currentOrderType === 'packages') {
          ReactSession.set('session', uuid());
          return;
        }
        
        let orderStatus = await validateOrderId(id);

        if (!orderStatus?.data?.valid) {
          orderStatus = await getStorageOrder(id);
          if (orderStatus == null) {
            navigate('/404');
            return;
          }
        } else {
          ReactSession.set('session', uuid());
        }
        
        dispatch({ type: 'RESET_REDUX_STORE' });
        dispatch(resetStore());
        localStorage.removeItem('storageState');
        
        const loginToken = getToken();
        
        if (!loginToken && currentOrderType === 'storage') {
          navigate('/storage-box/login', { state: { from: 'orderConfirmation' } });
          return;
        }
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      if (orderId && currentOrderType) {
        getorderFunc(orderId);
      }
    }, [orderId, currentOrderType]);

    if (!orderId) {
      return null;
    }
    
    const loginToken = getToken();
    if (currentOrderType === 'storage' && !loginToken) {
      return null;
    }

    return (
      <div>
        <section className="order-confirmation-section" style={{ marginTop: 0, paddingTop: 0 }}>
          <img
            src="img/order-confirmation.svg"
            className="img-fluid confirm-img-desktop"
            style={{ width: '100%', display: 'block', marginTop: 0 }}
          />
          <img
            src="img/order-confirmation-tab.svg"
            className="img-fluid confirm-img-tab"
            style={{ width: '100%', display: 'block', marginTop: 0 }}
          />
          <img
            src="img/order-confirmation-mobile.svg"
            className="img-fluid confirm-img-mobile"
            style={{ width: '100%', display: 'block', marginTop: 0 }}
          />

          <p className="confirmation-title">
            Thank you for
            <br /> your order!
          </p>
        </section>

        <div className="confirmation-content">
          <div className="content-box">
            <p>Your Order Id:</p>
            <p className="order-id color-secondary fw-700">{orderId}</p>

            {/* Conditional rendering based on order type */}
            {currentOrderType === 'storage' ? (
              <>
                <p className="page-titles">
                  You can now visit your My Account page to view your order and subscription details. Your Inventory page is also located there. This is where you can edit/update the content of your boxe(es) and request box deliveries once items are stored with us.
                </p>
                <p className="page-titles">
                  You will also receive an email from info@bluebox.rent and a text message from 858-252-0084 confirming the details of your order. Between 3 pm and 6 pm the day before your scheduled delivery date, you will receive a text message confirming your delivery time frame.
                </p>
              </>
            ) : currentOrderType === 'packages' ? (
              <>
                <p className="page-titles">
                  You should receive an email and a text message with all the details of your order.
                </p>
                <p className="page-titles">
                  We will send you a text message the day before your delivery and pickup dates confirming your drop off and pick up time frames
                </p>
                <p className="page-titles">
                  If you have any questions or need to change anything, please contact us by one of the methods below:
                </p>
              </>
            ) : null}

            <div className="row d-flex" style={{ alignItems: 'center' }}>
              <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 mb-3 support-icon align-content-center">
                <img src="img/icon-phone.svg" className="img-fluid" />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-8 col-xs-8 mb-3 support-title">
                <a
                  className="p-0 support-link"
                  style={{ fontWeight: '400' }}
                  href="tel:650-502-9522">
                  650-502-9522
                </a>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 mb-3 support-icon align-content-center">
                <img src="img/icon-email.svg" className="img-fluid" />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-8 col-xs-8 mb-3 support-title">
                <a
                  className="p-0 support-link"
                  style={{ fontWeight: '400' }}
                  href="mailto:info@bluebox.rent">
                  info@bluebox.rent
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }